import { Artist, Profile, Promoter, Venue } from '../../graphql/types.gen'

type EventParticipant = Artist | Venue | Promoter

export function profileCanBeEventParticipant(
  profile: Pick<Profile, '__typename'> | null | undefined,
): profile is EventParticipant {
  return !profile || profile.__typename !== 'User'
}
